import { useTheme, useMediaQuery } from '@mui/material'

export function useMobileBreakpoints() {
  const theme = useTheme()

  const isMobileLG = useMediaQuery(theme.breakpoints.down('lg'))
  const isMobileMD = useMediaQuery(theme.breakpoints.down('md'))
  const isMobileSM = useMediaQuery(theme.breakpoints.down('sm'))

  return { isMobileLG, isMobileMD, isMobileSM }
}
